import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetAdminPermissionSchema = () => {
  const [adminPermissionSchema, setAdminPermissionSchema] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdminPermissionSchema = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await RolesApi.getAdminPermissionSchema();
        setAdminPermissionSchema(data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            'Failed to fetch admin permission schema',
        );
        console.error('Error fetching admin permission schema:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminPermissionSchema();
  }, []);

  return {
    adminPermissionSchema,
    loading,
    error,
  };
};
